import medialogo_cnn from './media_cnn.svg';
import medialogo_consumer_affairs from './media_consumer_affairs.svg';
import medialogo_forbes from './media_forbes.svg';
import medialogo_fortune from './media_fortune.svg';
import medialogo_huffpost from './media_huffpost.svg';
import medialogo_investopedia from './media_investopedia.svg';
import medialogo_law360 from './media_law360.svg';
import medialogo_the_hill from './media_the_hill.svg';
import medialogo_us_news_world_360_badge from './media_us_news_world_360_badge.svg';
import medialogo_us_news_world from './media_us_news_world.svg';
import medialogo_yahoo from './media_yahoo.svg';

export const V2_MEDIALOGO_ICONS: { [char: string]: string } = {
  medialogo_cnn,
  medialogo_consumer_affairs,
  medialogo_forbes,
  medialogo_fortune,
  medialogo_huffpost,
  medialogo_investopedia,
  medialogo_law360,
  medialogo_the_hill,
  medialogo_us_news_world,
  medialogo_us_news_world_360_badge,
  medialogo_yahoo,
};

export const V2_MEDIALOGO_ICON_NAMES: string[] = Object.keys(V2_MEDIALOGO_ICONS);
